const ConditionalWrapper = ({ condition, wrapper, children, }) => (condition ? wrapper(children) : children);

export { ConditionalWrapper };
